import script from "./AppContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppContainer.vue?vue&type=script&setup=true&lang=ts"

import "@/components/layout/AppContainer.css?vue&type=style&index=0&id=651feb01&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651feb01"]])

export default __exports__